import { ApiService as api } from '@/services/axiosHelper';

export default new (class SnippetService {
	constructor() {}
	async SaveSnippet(snippet) {
		return await api.post('/snippets', snippet);
	}
	async UpdateSnippet(snippet) {
		const result = await api.put(`/snippets/${snippet.id}`, {
			description: snippet.description,
			snippetAttribute: snippet.snippetAttribute,
			snippetJustify: snippet.snippetJustify,
			snippetCalc: snippet.snippetCalc,
			snippetFormat: snippet.snippetFormat,
			message: snippet.message
		});
		return result;
	}
	async GetSnippet(id) {
		return await api.get(`/snippets/${id}`);
	}
	async DeleteSnippet(id) {
		return await api.delete(`/snippets/${id}`);
	}
})();
